<div class="flex flex-col gap-3 sm:gap-4">
  <!-- Stock Status Info -->
  <div class="flex flex-col">
    <span *ngIf="!canAddToCart" class="text-xs text-red-600">
      {{ 'Niedostępny' | translate }}
    </span>
    <span *ngIf="canAddToCart && hasBackorderAvailability" class="text-xs text-orange-600">
      {{ 'Dostępny na zamówienie' | translate }}
    </span>
    <span *ngIf="product?.quantity > 0 && product?.quantity <= 5" class="text-xs text-orange-600">
      {{ 'Pozostało' | translate }} {{ product.quantity }} {{ unitLabel }} {{ 'w magazynie' | translate }}
    </span>
  </div>

  <!-- Action Buttons with Quantity Controls -->
  <div class="flex flex-col sm:flex-row gap-2 sm:gap-3 items-stretch sm:items-center">
    <!-- Quantity Counter -->
    <div class="flex items-center bg-white border border-gray-300 rounded-full px-1 py-1 w-full sm:w-auto justify-center sm:justify-start">
      <button
        (click)="decrementQuantity()"
        [disabled]="quantity <= (saleUnit || 1)"
        class="flex items-center justify-center w-8 h-8 text-gray-600 hover:text-orange-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
        </svg>
      </button>

      <div class="flex items-center justify-center px-3 sm:px-4 py-1 min-w-[60px] sm:min-w-[80px]">
        <span class="text-sm sm:text-base text-gray-900 font-medium">{{ quantity }}</span>
        <span class="text-xs sm:text-sm text-gray-500 ml-1">
          {{ quantityUnitLabel }}
        </span>
      </div>

      <button
        (click)="incrementQuantity()"
        class="flex items-center justify-center w-8 h-8 text-gray-600 hover:text-orange-600 transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
      </button>
    </div>

    <!-- Add to Basket Button -->
    <button
      (click)="addToCart()"
      [disabled]="!canAddToCart"
      [class]="canAddToCart
        ? 'flex items-center justify-center gap-2 px-3 sm:px-4 py-2 sm:py-2.5 text-sm font-semibold text-white bg-orange-500 hover:bg-orange-600 transition-colors rounded-lg flex-1'
        : 'flex items-center justify-center gap-2 px-3 sm:px-4 py-2 sm:py-2.5 text-sm font-semibold text-white bg-gray-400 cursor-not-allowed rounded-lg flex-1'"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-4 h-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
        />
      </svg>
      <span>{{ (canAddToCart ? 'Dodaj do koszyka' : 'Niedostępny') | translate }}</span>
    </button>
  </div>
</div>
